define('SageDotCom/Components/AutoModal',["jquery"],
    function ($) {
        function AutoModal(scope, delayTime) {
            var $modal = $(".modal", scope);
            const delayTimeMs = parseInt(delayTime) !== null ? parseInt(delayTime) * 1000 : 3000;
            setTimeout(function () {     
                $modal = $modal.detach();
                $('body').append($modal);
                $modal.modal("show");
                $modal.modal({ backdrop: 'static', keyboard: false });
                $modal.focus();
                const $close = $(".dismiss, .close", $modal);
                $close.on("click",
                    function(e) {
                        e.preventDefault();
                        $modal.modal('hide');
                    });
            }, delayTimeMs);
        }   

        AutoModal.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new AutoModal(args.scope, args.delayTime);
        };

        return AutoModal;
    });

